import './Disclaimer.less'

const Disclaimer = () => (
    <p className="eta-disclaimer">
        Data is sourced from data.gov.hk (provided by various data providers). There may be delays or inaccuracies. This information is for reference only.
    </p>
)

export default Disclaimer
